/* ARDAS - Founder's Wardrobe combination builder.
 * Wires selection + live preview + carousel over server-rendered markup
 * (the DOM is produced by sections/founders-builder.liquid from Shopify data).
 * Vanilla JS, no dependencies. */
(function () {
  'use strict';
  function fmt(n){ try { return n.toLocaleString('en-IN'); } catch (e) { return n; } }
  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  ready(function () {
    var root = document.querySelector('[data-fwbuild]');
    if (!root) return;

    var picks = [].slice.call(root.querySelectorAll('.fwpick'));
    // Multi-select: any number of pieces from any category. .is-active on a
    // button is the single source of truth; no server/default selection.
    var allOpts = [].slice.call(root.querySelectorAll('.fwopt'));
    var nameEl = root.querySelector('[data-combo-name]');
    var priceEl = root.querySelector('[data-combo-price]');
    var stack = root.querySelector('[data-fwstack]');
    var emptyMsg = (stack && stack.querySelector('.fwstack__empty')) ? stack.querySelector('.fwstack__empty').textContent : 'Select pieces to build your combination.';

    function updatePreview(){
      var names = [], total = 0;
      if (stack) stack.innerHTML = '';
      // Iterate in DOM order so the readout stays stable regardless of click order.
      allOpts.forEach(function (btn) {
        if (!btn.classList.contains('is-active')) return;
        names.push(btn.dataset.name);
        total += parseInt(btn.dataset.price, 10) || 0;
        if (stack) {
          var slot = document.createElement('span');
          slot.className = 'fwstack__slot';
          var img = document.createElement('img');
          img.src = btn.dataset.img; img.alt = btn.dataset.name;
          slot.appendChild(img);
          stack.appendChild(slot);
        }
      });
      if (stack && names.length === 0) {
        var e = document.createElement('span');
        e.className = 'fwstack__empty label';
        e.textContent = emptyMsg;
        stack.appendChild(e);
      }
      if (nameEl) nameEl.textContent = names.join('  ·  ');
      if (priceEl) priceEl.textContent = fmt(total);
    }

    // Toggle selection: click a piece to add it, click again to remove it.
    allOpts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var on = btn.classList.toggle('is-active');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        setMsg('', '');
        updatePreview();
      });
    });

    // ---- "Book to Build This" -> add the whole selection to the Shopify cart ----
    var cta = root.querySelector('[data-fwbuild-cta]');
    var msgEl = root.querySelector('[data-fwbuild-msg]');

    function setMsg(text, state) {
      if (!msgEl) return;
      if (!text) { msgEl.hidden = true; msgEl.textContent = ''; msgEl.removeAttribute('data-state'); return; }
      msgEl.textContent = text;
      if (state) msgEl.setAttribute('data-state', state); else msgEl.removeAttribute('data-state');
      msgEl.hidden = false;
    }

    // Build [{ id, quantity }] from the active buttons, one line per selected
    // piece (each distinct product = its own cart line). No fake products, no
    // price changes - we add the real variant id rendered by Liquid.
    function selectedItems() {
      var items = [];
      allOpts.forEach(function (btn) {
        if (!btn.classList.contains('is-active')) return;
        var vid = btn.dataset.variantId;
        if (!vid || btn.dataset.unavailable === 'true') return;
        items.push({ id: vid, quantity: 1 });
      });
      return items;
    }

    if (cta) {
      cta.addEventListener('click', function (e) {
        // With zero selections, always block the action and show the message -
        // regardless of whether the AJAX cart is available (prevents the CTA
        // navigating away on an empty combination).
        var active = allOpts.filter(function (b) { return b.classList.contains('is-active'); });
        if (active.length === 0) {
          e.preventDefault();
          setMsg('Select at least one piece to build your combination.', 'error');
          return;
        }
        // With a selection but no AJAX cart, fall back to the CTA's normal href.
        if (!window.ARDAS_CART || typeof window.ARDAS_CART.addItems !== 'function') return;
        e.preventDefault();

        var items = selectedItems();
        if (items.length === 0) {
          setMsg('The selected pieces are currently unavailable. Please choose another combination.', 'error');
          return;
        }

        setMsg('Adding your combination to the bag…', 'ok');
        cta.setAttribute('aria-busy', 'true');
        window.ARDAS_CART.addItems(items)
          .then(function () {
            setMsg('', ''); // cart drawer opens on success
          })
          .catch(function (err) {
            var m = (err && err.description) ? err.description : 'Something went wrong adding to the bag. Please try again.';
            setMsg(m, 'error');
          })
          .then(function () { cta.removeAttribute('aria-busy'); });
      });
    }

    picks.forEach(function (pick) {
      var row = pick.querySelector('.fwpick__row');

      // ---- Carousel (only matters when a category overflows) ----
      var nav = pick.querySelector('.fwpick__nav');
      var arrows = pick.querySelectorAll('.fwpick__arrow');
      var prev = arrows[0], next = arrows[1];
      function step(){ var c = row.querySelector('.fwopt-cell'); var gap = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap || 0) || 0; return c ? c.getBoundingClientRect().width + gap : row.clientWidth * 0.85; }
      function refresh(){
        var overflow = row.scrollWidth - row.clientWidth > 1;
        pick.classList.toggle('has-overflow', overflow);
        if (prev) prev.disabled = row.scrollLeft <= 1;
        if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
      }
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
      row.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      refresh();
    });

    // ---- Default selection: pre-select exactly ONE Jacket on initial load ----
    // Picks the first available product in the Jackets group and gives it the
    // normal .is-active state, so it flows through updatePreview()/selectedItems()
    // like any user click. It remains fully toggleable (deselect/replace/add more)
    // and no Shirt or Trouser is defaulted.
    (function preselectFirstJacket(){
      var jacketPick = picks.filter(function (p) {
        var h = p.querySelector('.fwpick__head .index');
        return h && /jacket/i.test(h.textContent);
      })[0];
      if (!jacketPick) return;
      var opts = [].slice.call(jacketPick.querySelectorAll('.fwopt'));
      if (opts.some(function (b) { return b.classList.contains('is-active'); })) return;
      var first = opts.filter(function (b) { return b.dataset.unavailable !== 'true'; })[0] || opts[0];
      if (!first) return;
      first.classList.add('is-active');
      first.setAttribute('aria-pressed', 'true');
    })();

    updatePreview();
  });
})();
